import { repeat, size } from 'lodash/fp';

export const createFilename = guestId =>
  `clients_images/clients_${repeat(11 - size(guestId), '0').concat(
    guestId
  )}.jpg`;
